import React, { useState } from 'react';
import { Form, Radio, Input, Typography } from 'antd';
import type { FormInstance } from 'antd/lib/form';
import type { RadioChangeEvent } from 'antd/lib/radio/interface';

import { FETCH_TRAINER, CREATE_TRAINER } from './constants';
import { classPasswordFormRules } from 'services';

type TrainerFormProps = {
  form: FormInstance;
};

const TrainerForm: React.FC<TrainerFormProps> = ({ form }) => {
  const [type, setType] = useState(CREATE_TRAINER);

  const handleTypeChange = (event: RadioChangeEvent) => {
    const selectedType = event.target.value;

    setType(selectedType);
    if (selectedType === FETCH_TRAINER) {
      form.setFieldsValue({ trainerPassword: undefined });
    }
  };

  return (
    <div>
      <Typography.Title
        level={4}
        style={{ borderBottom: '1px solid #000', paddingBottom: 5 }}
      >
        Trainer
      </Typography.Title>

      <Form.Item>
        <Radio.Group value={type} onChange={handleTypeChange}>
          <Radio value={CREATE_TRAINER}>Create New</Radio>
          <Radio value={FETCH_TRAINER}>Existing</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item name="trainerName" label="Name" rules={[{ required: true }]}>
        <Input placeholder="john_doe" />
      </Form.Item>

      {type === CREATE_TRAINER && (
        <Form.Item
          name="trainerPassword"
          label="Password"
          rules={classPasswordFormRules}
        >
          <Input.Password placeholder="password" />
        </Form.Item>
      )}
    </div>
  );
};

export default TrainerForm;
